var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconPhone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 1582"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 3",
    cx: 18.5,
    cy: 18.5,
    r: 18,
    fill: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.9286 26.5C14.5357 26.5 14.1994 26.3576 13.9196 26.0727C13.6399 25.7879 13.5 25.4455 13.5 25.0455V11.9545C13.5 11.5545 13.6399 11.2121 13.9196 10.9273C14.1994 10.6424 14.5357 10.5 14.9286 10.5H22.0714C22.4643 10.5 22.8006 10.6424 23.0804 10.9273C23.3601 11.2121 23.5 11.5545 23.5 11.9545V25.0455C23.5 25.4455 23.3601 25.7879 23.0804 26.0727C22.8006 26.3576 22.4643 26.5 22.0714 26.5H14.9286ZM18.5 24.6818C18.7024 24.6818 18.872 24.6121 19.0089 24.4727C19.1458 24.3333 19.2143 24.1606 19.2143 23.9545C19.2143 23.7485 19.1458 23.5758 19.0089 23.4364C18.872 23.297 18.7024 23.2273 18.5 23.2273C18.2976 23.2273 18.128 23.297 17.9911 23.4364C17.8542 23.5758 17.7857 23.7485 17.7857 23.9545C17.7857 24.1606 17.8542 24.3333 17.9911 24.4727C18.128 24.6121 18.2976 24.6818 18.5 24.6818ZM14.9286 21.4091H22.0714V14.1364H14.9286V21.4091Z",
    fill: "#0BA9E0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPhone);
export default __webpack_public_path__ + "static/media/icon-phone.2cae7bd2ad7c65bc5a47e4b2e31c4bec.svg";
export { ForwardRef as ReactComponent };